
  import { Vue, Component, Prop } from "vue-property-decorator";
  import Chip from "@/components/filters/Chip.vue";
  import RouteNames from "@/entities/RouteNames";

  @Component({
    components: {
      Chip,
    },
  })
  export default class ProjectChip extends Vue {
    @Prop({type: String, required: true}) readonly projectId!: string;
    @Prop({type: String, required: true}) readonly projectName!: string;

    routes = RouteNames;
  };
